/* eslint-disable import/no-dynamic-require */
/* eslint-disable global-require */
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Button } from 'reactstrap';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from '../../../assets/styles/style.sass';
import { setIsShowRegisterModal } from '../../../actions/user';
// const messagesRef = LoginRegisterMessagesRef;

class RegisterButton extends React.Component {
  static propTypes = {
    currentLocale: PropTypes.string.isRequired,
    setIsShowRegisterModal: PropTypes.func.isRequired,
  };

  constructor(props) {
    super(props);
    const langType = props.currentLocale.split('-')[0];
    const lang = props.currentLocale.split('-')[1].toLowerCase();
    let fileLang = '';
    if (lang === 'hk') {
      fileLang = `${langType}_${lang}/`;
    }
    this.state = {
      modelDataDefaultLocale: require(`../../../assets/json/default//setting/general/locale.json`),
      modelDataLocale: require(`../../../assets/json/${lang}/${fileLang}setting/general/locale.json`),
    };
    this.toggle = this.toggle.bind(this);
  }

  toggle() {
    this.props.setIsShowRegisterModal();
  }

  render() {
    return (
      <span>
        <Button
          onClick={() => {
            this.toggle();
          }}
          className={`${s.headerMenuButton} ${s.rightRadius} ${s.button} ${
            s.secondary
          } ${s.outlined} dialog`}
        >
          {typeof this.state.modelDataLocale.page_register === 'undefined'
            ? this.state.modelDataDefaultLocale.page_register
            : this.state.modelDataLocale.page_register}
        </Button>
      </span>
    );
  }
}
const mapState = state => ({
  currentLocale: state.intl.locale,
  isShowRegisterModal: state.user.isShowRegisterModal,
});
const mapDispatch = {
  setIsShowRegisterModal,
};
export default connect(mapState, mapDispatch)(withStyles(s)(RegisterButton));



// WEBPACK FOOTER //
// ./src/components/Header/Button/RegisterButton.js